﻿import {Core} from "../../Base/Core";
import {UIText} from "../Tools/Base/UIText";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {RewardedAdsBtn} from "../RewardedAdsBtn";

export class UITapChallengeLost extends UICommonPopup {
    Awake() {
        super.Awake();

        this.onClickTake = this.onClickTake.bind(this);
        this.onClickTakeMore = this.onClickTakeMore.bind(this);
        this.onShown = this.onShown.bind(this);

        this.takeMoreText = this.content.addChild(new UIText(Core.Localizator.Get("tap_challenge_defeat"), {wordWrap: true}));

        this.takeBtn = this.content.addChild(
            new UINineSliceButton("btn-blue", {
                label: Core.Localizator.Get("tap_challenge_defeat_continue"),
            })
        );

        this.takeMoreBtn = this.content.addChild(
            new RewardedAdsBtn("btn-green", {
                label: Core.Localizator.Get("tap_challenge_defeat_second_chance", Core.GameData.TapChallenge.additionalTime),
                icon: "play-icon",
                iconAlign: "left",
            })
        );

        this._results = null; // TapChallengeResult
        this._reward = null; // Reward
    }

    Init() {
        super.Init();
        this.takeBtn.on("pointertap", this.onClickTake);
        this.takeMoreBtn.on("pointertap", this.onClickTakeMore);
    }

    onClickTakeMore() {
        Core.Ads.TriggerRewarded(this.onShown);
    }

    onShown() {
        Core.UI.tapChallenge.Show(this._results);
        this.Hide();
    }

    onClickTake() {
        Core.Ads.TriggerInterstitial();
        this.Hide();
    }

    Show(results) {
        console.log("TAP CHALLENGE LOST");
        this._results = results;
        this.takeMoreBtn.label = Core.Localizator.Get("tap_challenge_defeat_second_chance", Core.GameData.TapChallenge.additionalTime);
        this.fitLayout();
        super.Show();
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 0.9;
        let w = Math.min(viewport.width * 0.6, (viewport.height * 0.6) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.5, w, h));

        super.fitLayout(viewport);

        let popupRect = this.getContentSize();

        let rect = popupRect.clone();
        rect.height = popupRect.height * 0.3;
        rect.width = popupRect.width * 0.9;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = popupRect.height * 0.2;
        this.takeMoreText.fitLayout(rect);

        rect = popupRect.clone();
        rect.width = popupRect.width * 0.41;
        rect.height = popupRect.height * 0.25;
        rect.x = (popupRect.width - rect.width) * 0.11;
        rect.y = (popupRect.height - rect.height) * 0.87;
        this.takeBtn.fitLayout(rect);

        rect.x = (popupRect.width - rect.width) * 0.89;
        this.takeMoreBtn.fitLayout(rect);
    }
}
